import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private overlayRef?: OverlayRef;

  constructor(private overlay: Overlay, private injector: Injector) {}

  async openPricingPopup(): Promise<void> {
    if (this.overlayRef) {
      this.close(); 
    }
  
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'dark-backdrop',
      panelClass: 'popup-panel',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });
  
    const { PricingPopupComponent } = await import('./pricing-popup.component');
    const popupPortal = new ComponentPortal(PricingPopupComponent, null, this.injector);
    const componentRef = this.overlayRef.attach(popupPortal);
  
    this.overlayRef.backdropClick().subscribe(() => this.close());
    componentRef.instance.close = () => this.close();
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = undefined;
    }
  }
}
